// src/app/features/payments/checkout/components/sections/PaymentMethodSection.tsx
import { CreditCard } from "lucide-react";
import { motion } from "motion/react";
import { useState } from "react";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

interface PaymentMethodSectionProps {
  onMethodSelected: (isSelected: boolean) => void;
}

export function PaymentMethodSection({ onMethodSelected }: PaymentMethodSectionProps) {
  const [isTelegramStarsSelected, setIsTelegramStarsSelected] = useState(false);
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="mb-6 rounded-2xl border border-white/20 dark:border-white/20 bg-white/5 dark:bg-white/5 backdrop-blur-sm p-6 shadow-sm"
    >
      <div className="mb-4 flex items-center gap-3">
        <CreditCard className="h-5 w-5 text-muted-foreground" />
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">{t('paymentMethod')}</h2>
      </div>
      <button
        type="button"
        onClick={() => {
          const next = !isTelegramStarsSelected;
          setIsTelegramStarsSelected(next);
          onMethodSelected(next);
        }}
        className={`w-full rounded-xl border p-4 text-left ${
          isTelegramStarsSelected ? "border-violet-500 bg-violet-50 dark:bg-violet-900/30" : "border-border bg-transparent"
        }`}
      >
        <span className="text-foreground">Telegram Stars</span>
      </button>
    </motion.div>
  );
}